import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import TableCell from "@mui/material/TableCell"
import Typography from "@mui/material/Typography"
import PropTypes from "prop-types"
import { useState } from "react"

import Column from "../../../common/components/Column"
import Row from "../../../common/components/Row"
import { trimLongString } from "../../../common/utils"
import { adminTableBodyCellSx } from "./AdminHeaderTableCell"

const PREVIEW_CHAR_LIMIT = 20

export default function AdminVoicemailTranscriptCell({
  transcript,
  fromPhone,
  didPhone,
  created,
  conciergeName,
  ownerName,
}) {
  const [open, setOpen] = useState(false)
  const text = transcript == null ? "" : String(transcript).trim()
  const preview = text ? trimLongString(text, PREVIEW_CHAR_LIMIT) : "—"
  const hasTranscript = Boolean(text)

  return (
    <>
      <TableCell
        sx={{
          ...adminTableBodyCellSx,
          maxWidth: { xs: 160, sm: 220, md: 260 },
        }}
      >
        <Row gap={1} sx={{ alignItems: "center", minWidth: 0 }}>
          <Typography
            variant="body2"
            color="text.secondary"
            noWrap
            sx={{ flex: 1, minWidth: 0 }}
          >
            {preview}
          </Typography>
          {hasTranscript ? (
            <Button
              size="small"
              variant="outlined"
              onClick={() => setOpen(true)}
              sx={{ flexShrink: 0 }}
            >
              View
            </Button>
          ) : null}
        </Row>
      </TableCell>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Voicemail transcript</DialogTitle>
        <DialogContent>
          <Column gap={1.5} sx={{ pt: 0.5 }}>
            {(created ||
              fromPhone ||
              didPhone ||
              conciergeName ||
              ownerName) && (
              <Column gap={0.25}>
                {created ? (
                  <Typography variant="caption" color="text.secondary">
                    Received: {created}
                  </Typography>
                ) : null}
                {fromPhone ? (
                  <Typography variant="caption" color="text.secondary">
                    From: {fromPhone}
                  </Typography>
                ) : null}
                {didPhone ? (
                  <Typography variant="caption" color="text.secondary">
                    DID: {didPhone}
                  </Typography>
                ) : null}
                {conciergeName ? (
                  <Typography variant="caption" color="text.secondary">
                    Concierge: {conciergeName}
                  </Typography>
                ) : null}
                {ownerName ? (
                  <Typography variant="caption" color="text.secondary">
                    Owner: {ownerName}
                  </Typography>
                ) : null}
              </Column>
            )}
            <Typography variant="body1" sx={{ whiteSpace: "pre-wrap" }}>
              {text}
            </Typography>
          </Column>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

AdminVoicemailTranscriptCell.propTypes = {
  transcript: PropTypes.string,
  fromPhone: PropTypes.string,
  didPhone: PropTypes.string,
  created: PropTypes.string,
  conciergeName: PropTypes.string,
  ownerName: PropTypes.string,
}
